



























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { LinkIcon, MailIcon } from 'vue-feather-icons';

@Component({
  components: { LinkIcon, MailIcon },
})
export default class FormInputMagicLink extends Vue {
  @Prop({ required: true, type: [String, Number] })
  readonly value!: string | number;

  @Prop({ required: false, type: Boolean, default: false })
  readonly required!: boolean;

  @Prop({ required: false, type: Array })
  errors!: string[];

  mouseOver = false;

  @Prop({ type: Boolean, default: false })
  magicLinkHint!: boolean;

  @Watch('magicLinkHint')
  onMagicLinkHintChange(newVal: boolean) {
    if (newVal) {
      (this.$refs['btn-send'] as HTMLElement).focus();
    }
  }

  submitMagicLink(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.$emit('submit-magic-link');
    return;
  }
  validateEmail() {
    return /\S+@\S+\.\S+/.test((this.value as string) || '');
  }
}
